
import { useForm, isNotEmpty } from '@mantine/form';
import { Button, Group, TextInput, Modal } from '@mantine/core';
import { AppContext } from '../../../context/context';
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { showNotification } from '@mantine/notifications';

const FormCarrier = ({ id, reloadtable }) => {

    const appcontext = useContext(AppContext);
    const [title, setTitle] = useState('Nuevo')

    useEffect(() => {
        if (id != '' && appcontext.openedFCCC) {
            getDataFromId(id);
            setTitle('Editar codigo carrier');
        } else {
            setTitle('Nuevo codigo carrier');
            form.reset();
        }
    }, [appcontext.openedFCCC]);

    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
            CODIGO: '',
            COMENTARIO: ''
        },

        validate: {
            CODIGO: isNotEmpty('Debes ingresar un valor'),
        },
    });


    const handleClickNew = async (values) => {
        try {
            values.USUARIO_ACTUALIZACION = sessionStorage.getItem("user");
            await axios.post(process.env.REACT_APP_API_URL_DE + '/api/carriers', values, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                }
            });
            showNotification({
                title: 'Listo!',
                message: 'Codigo carrier guardado con exito',
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#25A661',
                        borderColor: '#25A661',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
            reloadtable('Carrier');
            form.reset();
        } catch (err) {
            showNotification({
                title: 'Error!',
                message: err.response?.data?.error ? err.response.data.error : err.message,
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        }
    }

    const handleClickUpdate = async (values) => {
        try {
            values.USUARIO_ACTUALIZACION = sessionStorage.getItem("user");
            await axios.put(process.env.REACT_APP_API_URL_DE + `/api/carriers/${id}`, values, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                }
            });
            showNotification({
                title: 'Listo!',
                message: 'Codigo carrier actualizado con exito',
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#25A661',
                        borderColor: '#25A661',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
            reloadtable('Carrier');
            appcontext.setStatusFCCC(false);
        } catch (err) {
            showNotification({
                title: 'Error!',
                message: err.response?.data?.error ? err.response.data.error : err.message,
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        }

    }

    const getDataFromId = async (id) => {
        try {
            var response = await axios.post(process.env.REACT_APP_API_URL_DE + '/api/carriers/onecode', { id: id }, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                }
            });

            let result = response.data;
            form.setValues({
                CODIGO: result.CODIGO,
                DESCRIPCION: result.DESCRIPCION,
                COMENTARIO: result.COMENTARIO
            });
        } catch (err) {
            showNotification({
                title: 'Error!',
                message: err.response?.data?.error ? err.response.data.error : err.message,
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        }
    }

    return (
        <Modal opened={appcontext.openedFCCC} onClose={() => { appcontext.setStatusFCCC(false); }} title={title}>
            <form onSubmit={form.onSubmit((values) => { id == '' ? handleClickNew(values) : handleClickUpdate(values) })}>
                <TextInput
                    label="Codigo Carrier"
                    placeholder="Codigo"
                    mt="md"
                    withAsterisk
                    key={form.key('CODIGO')}
                    {...form.getInputProps('CODIGO')}
                />
                <TextInput
                    label="Comentario"
                    placeholder="Comentario"
                    mt="md"
                    key={form.key('COMENTARIO')}
                    {...form.getInputProps('COMENTARIO')}
                />
                <Group justify="flex-end" mt="md">
                    <Button type="button" variant='outline' onClick={() => { appcontext.setStatusFCCC(false); }}>Cerrar</Button>
                    <Button type="submit">Guardar</Button>
                </Group>
            </form>
        </Modal>
    );

}

export default FormCarrier;